export default "__VITE_ASSET__ekCu0Wkj__"